var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import ChildComponent from '../ChildComponent';
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
var StyledFieldSet = styled.fieldset(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
export function GroupBox(props) {
    var componentStyle = props.componentStyle, _a = props.fieldSetStyle, fieldSetStyle = _a === void 0 ? {} : _a, _b = props.legendStyle, legendStyle = _b === void 0 ? {} : _b, legend = props.legend, children = props.children;
    return (React.createElement(StyledDiv, { componentStyle: componentStyle },
        React.createElement(StyledFieldSet, { componentStyle: fieldSetStyle },
            legend && (React.createElement("legend", null,
                React.createElement(StyledDiv, { componentStyle: legendStyle }, legend))),
            React.createElement(ChildComponent, { children: children }))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=GroupBox.js.map